var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header-component',{attrs:{"title":"Application for Employment"}}),_c('application-form-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }